import { I4BColumnConfiguration } from './configurations';
import { registerDefaultColumnsResolver } from './default-columns.registry';
import { DefaultActiveAssetEventsPopupGrid } from './default-active-asset-events-popup-grid.definition';
import {
  DefaultAssetEventsByAssetGrid,
  GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_BY_ASSET_VIEW,
  GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_BY_ASSET_VIEW
} from './default-asset-events-by-asset-grid.definition';
import {
  DefaultAssetEventsByPERuleGrid,
  GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_BY_PE_RULE_VIEW,
  GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_BY_PE_RULE_VIEW
} from './default-asset-events-by-pe-rule-grid.definition';
import {
  DefaultAssetEventsBySiteGrid,
  GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_BY_SITE_VIEW,
  GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_BY_SITE_VIEW
} from './default-asset-events-by-site-grid.definition';
import {
  DefaultAssetEventsByTopicGrid,
  GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_BY_TOPIC_VIEW,
  GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_BY_TOPIC_VIEW
} from './default-asset-events-by-topic-grid.definition';
import {
  DefaultAssetEventsGrid,
  GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_VIEW,
  GET_DEFAULT_DEVICES_COLUMNS_FOR_ASSETS_EVENTS_VIEW,
  GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_VIEW,
  GET_DEFAULT_SITES_COLUMNS_FOR_ASSET_EVENTS_VIEW
} from './default-asset-events-grid.definition';

import {
  DefaultAssetsGrid,
  GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSETS_VIEW,
  GET_DEFAULT_SITES_COLUMNS_FOR_ASSETS_VIEW,
  GET_DEFAULT_TECHNICAL_COLUMNS_FOR_ASSETS_VIEW,
  GET_FOLLOWED_VARIABLES_COLUMNS_FOR_ASSETS_VIEW,
  GET_STANDARD_VARIABLES_COLUMNS_FOR_ASSETS_VIEW
} from './default-asset-grid.definition';
import { DefaultAssetTemplatesGrid, GET_DEFAULT_ASSET_TEMPLATES_COLUMNS_FOR_ASSET_TEMPLATES_VIEW } from './default-asset-templates-grid.definition';
import { GET_DEFAULT_DEVICES_COLUMNS_FOR_BAM_DEVICES_VIEW } from './default-bam-device-grid.definition';
import { GET_DEFAULT_DEVICE_TEMPLATES_COLUMNS_FOR_BAM_DEVICE_TEMPLATES_VIEW } from './default-bam-device-templates-grid.definition';
import { DefaultCalendarsGrid, GET_DEFAULT_CALENDARS_COLUMNS_FOR_CALENDARS_VIEW } from './default-calendars-grid.definition';
import { DefaultConnectorsGrid, GET_DEFAULT_CONNECTORS_COLUMNS_FOR_CONNECTORS_VIEW } from './default-connectors-grid.definition';
import {
  GET_DEFAULT_DEVICES_COLUMNS_FOR_DALIA_DEVICES_VIEW,
  GET_DEFAULT_DIAGNOSTIC_VARIABLE_COLUMNS_FOR_DALIA_DEVICE_VIEW
} from './default-dalia-device-grid.definition';
import { GET_DEFAULT_DEVICE_TEMPLATES_COLUMNS_FOR_DALIA_DEVICE_TEMPLATES_VIEW } from './default-dalia-device-templates-grid.definition';
import { GET_DEFAULT_DEVICES_CONFIGURATION_COLUMNS_FOR_DALIA_DEVICES_CONFIGURATION_VIEW } from './default-dalia-devices-configuration-grid.definition';
import { GET_DEFAULT_FIRMWARES_COLUMNS_FOR_DALIA_FIRMWARES_VIEW } from './default-dalia-firmwares-grid.definition';
import { GET_DEFAULT_SENSORS_COLUMNS_FOR_DALIA_SENSORS_VIEW } from './default-dalia-sensors-grid.definition';
import {
  DefaultDeviceEventsByDeviceGrid,
  GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICE_EVENTS_BY_DEVICE_VIEW,
  GET_DEFAULT_EVENTS_COLUMNS_FOR_DEVICE_EVENTS_BY_DEVICE_VIEW
} from './default-device-events-by-device-grid.definition';
import {
  DefaultDeviceEventsByPERuleGrid,
  GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICE_EVENTS_BY_PE_RULE_VIEW,
  GET_DEFAULT_EVENTS_COLUMNS_FOR_DEVICE_EVENTS_BY_PE_RULE_VIEW
} from './default-device-events-by-pe-rule-grid.definition';
import {
  DefaultDeviceEventsBySiteGrid,
  GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICE_EVENTS_BY_SITE_VIEW,
  GET_DEFAULT_EVENTS_COLUMNS_FOR_DEVICE_EVENTS_BY_SITE_VIEW
} from './default-device-events-by-site-grid.definition';
import {
  DefaultDeviceEventsByTopicGrid,
  GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICE_EVENTS_BY_TOPIC_VIEW,
  GET_DEFAULT_EVENTS_COLUMNS_FOR_DEVICE_EVENTS_BY_TOPIC_VIEW
} from './default-device-events-by-topic-grid.definition';
import {
  DefaultDeviceEventsGrid,
  GET_DEFAULT_ASSET_COLUMNS_FOR_DEVICE_EVENTS_VIEW,
  GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICE_EVENTS_VIEW,
  GET_DEFAULT_EVENTS_COLUMNS_FOR_DEVICE_EVENTS_VIEW,
  GET_DEFAULT_SITES_COLUMNS_FOR_DEVICE_EVENTS_VIEW
} from './default-device-events-grid.definition';
import {
  DefaultDevicesGrid,
  GET_DEFAULT_CONNECTIVITY_MODULE_COLUMNS_FOR_DEVICES_VIEW,
  GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICES_VIEW,
  GET_DEFAULT_DIAGNOSTIC_VARIABLE_COLUMNS_FOR_DEVICE_VIEW,
  GET_DEFAULT_SITES_COLUMNS_FOR_DEVICES_VIEW,
  GET_DEFAULT_TECHNICAL_COLUMNS_FOR_DEVICES_VIEW
} from './default-device-grid.definition';

import { DefaultEmailTemplatesGrid, GET_DEFAULT_EMAIL_TEMPLATES_COLUMNS_FOR_EMAIL_TEMPLATES_VIEW } from './default-email-templates-grid.definition';
import {
  DefaultEscalationProtocolsGrid,
  GET_DEFAULT_ESCALATION_PROTOCOLS_COLUMNS_FOR_ESCALATION_PROTOCOLS_VIEW
} from './default-escalation-protocols-grid.definition';
import { GET_DEFAULT_DEVICES_COLUMNS_FOR_KERCOM_DEVICES_VIEW } from './default-kercom-device-grid.definition';
import { GET_DEFAULT_DEVICES_COLUMNS_FOR_NTE_DEVICES_VIEW } from './default-nte-device-grid.definition';
import { GET_DEFAULT_DEVICE_MODELS_COLUMNS_FOR_NTE_DEVICE_MODELS_VIEW } from './default-nte-device-models-grid.definition';
import { GET_DEFAULT_DEVICE_TEMPLATES_COLUMNS_FOR_NTE_DEVICE_TEMPLATES_VIEW } from './default-nte-device-templates-grid.definition';
import { GET_DEFAULT_PERIPHERALS_COLUMNS_FOR_NTE_PERIPHERALS_VIEW } from './default-nte-peripherals-grid.definition';
import { GET_DEFAULT_PO_EVENT_RULES_COLUMNS_FOR_PO_EVENT_RULES_VIEW } from './default-po-event-rules-grid.definition';
import { DefaultProductsGrid, GET_DEFAULT_PRODUCTS_COLUMNS_FOR_PRODUCTS_VIEW } from './default-products-grid.definition';
import {
  DefaultSitesGrid,
  GET_DEFAULT_GEOLOCATION_COLUMNS_FOR_SITES_VIEW,
  GET_DEFAULT_SITES_COLUMNS_FOR_SITES_VIEW,
  GET_DEFAULT_TECHNICAL_COLUMNS_FOR_SITES_VIEW
} from './default-sites-grid.definition';
import {
  DefaultStockSiteDevicesGrid,
  GET_DEFAULT_DEVICE_COLUMNS_FOR_STOCK_SITE_DEVICES_VIEW,
  GET_DEFAULT_TECHNICAL_COLUMNS_FOR_STOCK_SITE_DEVICES_VIEW
} from './default-stock-site-devices-grid.definition';
import { DefaultTeamPlanningsGrid, GET_DEFAULT_TEAM_PLANNINGS_COLUMNS_FOR_TEAM_PLANNINGS_VIEW } from './default-team-plannings-grid.definition';
import { DefaultTopicsGrid, GET_DEFAULT_TOPICS_COLUMNS_FOR_TOPICS_VIEW } from './default-topics-grid.definition';
import { GET_DEFAULT_USERS_COLUMNS_FOR_USERS_VIEW } from './default-users-grid.definition';
import { GET_DEFAULT_DEVICES_COLUMNS_FOR_XMQTT_DEVICES_VIEW } from './default-xmqtt-device-grid.definition';
import { I4BColumn } from './definitions';
import { I4bCellConcept } from './enums';
import { I4BColumnHeader } from './models';
import { I4BColumnOptions } from './options';
import { DefaultSchedulersGrid, GET_DEFAULT_SCHEDULERS_COLUMNS_FOR_SCHEDULERS_VIEW } from './default-schedulers-grid.definition';

export const defaultGridsDefinitions: {
  viewType: string;
  dataLibraries: {
    libraryName: string;
    columns: I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[];
  }[];
}[] = [
  {
    viewType: 'SITES',
    dataLibraries: [
      {
        libraryName: 'SITES',
        columns: GET_DEFAULT_SITES_COLUMNS_FOR_SITES_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      },
      {
        libraryName: 'GEOLOCATION',
        columns: GET_DEFAULT_GEOLOCATION_COLUMNS_FOR_SITES_VIEW()
      },
      {
        libraryName: 'TECHNICAL',
        columns: GET_DEFAULT_TECHNICAL_COLUMNS_FOR_SITES_VIEW()
      }
    ]
  },
  {
    viewType: 'STOCK-SITE-DEVICES',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICE_COLUMNS_FOR_STOCK_SITE_DEVICES_VIEW()
      },
      {
        libraryName: 'TECHNICAL',
        columns: GET_DEFAULT_TECHNICAL_COLUMNS_FOR_STOCK_SITE_DEVICES_VIEW()
      }
    ]
  },
  {
    viewType: 'ASSETS',
    dataLibraries: [
      {
        libraryName: 'SITES',
        columns: GET_DEFAULT_SITES_COLUMNS_FOR_ASSETS_VIEW()
      },
      {
        libraryName: 'ASSETS',
        columns: GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSETS_VIEW()
      },
      {
        libraryName: 'FOLLOWED VARIABLES',
        columns: GET_FOLLOWED_VARIABLES_COLUMNS_FOR_ASSETS_VIEW()
      },
      {
        libraryName: 'STANDARD VARIABLES',
        columns: GET_STANDARD_VARIABLES_COLUMNS_FOR_ASSETS_VIEW()
      },
      {
        libraryName: 'CUSTOM VARIABLES',
        columns: []
      },
      {
        libraryName: 'TAGS',
        columns: []
      },
      {
        libraryName: 'TECHNICAL',
        columns: GET_DEFAULT_TECHNICAL_COLUMNS_FOR_ASSETS_VIEW()
      }
    ]
  },
  {
    viewType: 'DEVICES',
    dataLibraries: [
      {
        libraryName: 'SITES',
        columns: GET_DEFAULT_SITES_COLUMNS_FOR_DEVICES_VIEW()
      },
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICES_VIEW()
      },
      {
        libraryName: 'DIAGNOSTIC VARIABLES',
        columns: GET_DEFAULT_DIAGNOSTIC_VARIABLE_COLUMNS_FOR_DEVICE_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      },
      {
        libraryName: 'TECHNICAL',
        columns: GET_DEFAULT_TECHNICAL_COLUMNS_FOR_DEVICES_VIEW()
      },
      {
        libraryName: 'CONNECTIVITY_MODULE',
        columns: GET_DEFAULT_CONNECTIVITY_MODULE_COLUMNS_FOR_DEVICES_VIEW()
      }
    ]
  },
  {
    viewType: 'DALIA-DEVICES',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_DALIA_DEVICES_VIEW()
      },
      {
        libraryName: 'DIAGNOSTIC VARIABLES',
        columns: GET_DEFAULT_DIAGNOSTIC_VARIABLE_COLUMNS_FOR_DALIA_DEVICE_VIEW()
      },
      {
        libraryName: 'CONNECTIVITY_MODULE',
        columns: GET_DEFAULT_CONNECTIVITY_MODULE_COLUMNS_FOR_DEVICES_VIEW()
      }
    ]
  },
  {
    viewType: 'DALIA-DEVICES-CONFIGURATION',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_CONFIGURATION_COLUMNS_FOR_DALIA_DEVICES_CONFIGURATION_VIEW()
      }
    ]
  },
  {
    viewType: 'XMQTT-DEVICES',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_XMQTT_DEVICES_VIEW()
      },
      {
        libraryName: 'CONNECTIVITY_MODULE',
        columns: GET_DEFAULT_CONNECTIVITY_MODULE_COLUMNS_FOR_DEVICES_VIEW()
      }
    ]
  },
  {
    viewType: 'NTE-DEVICES',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_NTE_DEVICES_VIEW()
      },
      {
        libraryName: 'CONNECTIVITY_MODULE',
        columns: GET_DEFAULT_CONNECTIVITY_MODULE_COLUMNS_FOR_DEVICES_VIEW()
      }
    ]
  },
  {
    viewType: 'NTE-DEVICE-MODELS',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICE_MODELS_COLUMNS_FOR_NTE_DEVICE_MODELS_VIEW()
      }
    ]
  },
  {
    viewType: 'NTE-PERIPHERALS',
    dataLibraries: [
      {
        libraryName: 'PERIPHERALS',
        columns: GET_DEFAULT_PERIPHERALS_COLUMNS_FOR_NTE_PERIPHERALS_VIEW()
      }
    ]
  },
  {
    viewType: 'NTE-DEVICE-TEMPLATES',
    dataLibraries: [
      {
        libraryName: 'DEVICE TEMPLATES',
        columns: GET_DEFAULT_DEVICE_TEMPLATES_COLUMNS_FOR_NTE_DEVICE_TEMPLATES_VIEW()
      }
    ]
  },
  {
    viewType: 'BAM-DEVICES',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_BAM_DEVICES_VIEW()
      },
      {
        libraryName: 'CONNECTIVITY_MODULE',
        columns: GET_DEFAULT_CONNECTIVITY_MODULE_COLUMNS_FOR_DEVICES_VIEW()
      }
    ]
  },
  {
    viewType: 'KERCOM-DEVICES',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_KERCOM_DEVICES_VIEW()
      },
      {
        libraryName: 'CONNECTIVITY_MODULE',
        columns: GET_DEFAULT_CONNECTIVITY_MODULE_COLUMNS_FOR_DEVICES_VIEW()
      }
    ]
  },
  {
    viewType: 'KERCOM-V2-DEVICES',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_KERCOM_DEVICES_VIEW()
      },
      {
        libraryName: 'CONNECTIVITY_MODULE',
        columns: GET_DEFAULT_CONNECTIVITY_MODULE_COLUMNS_FOR_DEVICES_VIEW()
      }
    ]
  },
  {
    viewType: 'DALIA-FIRMWARES',
    dataLibraries: [
      {
        libraryName: 'FIRMWARES',
        columns: GET_DEFAULT_FIRMWARES_COLUMNS_FOR_DALIA_FIRMWARES_VIEW()
      }
    ]
  },
  {
    viewType: 'DALIA-SENSORS',
    dataLibraries: [
      {
        libraryName: 'SENSORS',
        columns: GET_DEFAULT_SENSORS_COLUMNS_FOR_DALIA_SENSORS_VIEW()
      }
    ]
  },
  {
    viewType: 'DALIA-DEVICE-TEMPLATES',
    dataLibraries: [
      {
        libraryName: 'DEVICE TEMPLATES',
        columns: GET_DEFAULT_DEVICE_TEMPLATES_COLUMNS_FOR_DALIA_DEVICE_TEMPLATES_VIEW()
      }
    ]
  },
  {
    viewType: 'BAM-DEVICE-TEMPLATES',
    dataLibraries: [
      {
        libraryName: 'DEVICE TEMPLATES',
        columns: GET_DEFAULT_DEVICE_TEMPLATES_COLUMNS_FOR_BAM_DEVICE_TEMPLATES_VIEW()
      }
    ]
  },
  {
    viewType: 'DEVICE-EVENTS',
    dataLibraries: [
      {
        libraryName: 'SITES',
        columns: GET_DEFAULT_SITES_COLUMNS_FOR_DEVICE_EVENTS_VIEW()
      },
      {
        libraryName: 'ASSETS',
        columns: GET_DEFAULT_ASSET_COLUMNS_FOR_DEVICE_EVENTS_VIEW()
      },
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICE_EVENTS_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_DEVICE_EVENTS_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'ASSET-EVENTS',
    dataLibraries: [
      {
        libraryName: 'SITES',
        columns: GET_DEFAULT_SITES_COLUMNS_FOR_ASSET_EVENTS_VIEW()
      },
      {
        libraryName: 'ASSETS',
        columns: GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_VIEW()
      },
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_ASSETS_EVENTS_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'EMAIL-TEMPLATES',
    dataLibraries: [
      {
        libraryName: 'EMAIL TEMPLATES',
        columns: GET_DEFAULT_EMAIL_TEMPLATES_COLUMNS_FOR_EMAIL_TEMPLATES_VIEW()
      }
    ]
  },
  {
    viewType: 'CONNECTORS',
    dataLibraries: [
      {
        libraryName: 'CONNECTORS',
        columns: GET_DEFAULT_CONNECTORS_COLUMNS_FOR_CONNECTORS_VIEW()
      }
    ]
  },
  {
    viewType: 'ASSET-TEMPLATES',
    dataLibraries: [
      {
        libraryName: 'ASSET TEMPLATES',
        columns: GET_DEFAULT_ASSET_TEMPLATES_COLUMNS_FOR_ASSET_TEMPLATES_VIEW()
      }
    ]
  },
  {
    viewType: 'ACTIVE-ASSET-EVENTS-POPUP',
    dataLibraries: [
      {
        libraryName: 'SITES',
        columns: GET_DEFAULT_SITES_COLUMNS_FOR_ASSET_EVENTS_VIEW()
      },
      {
        libraryName: 'ASSETS',
        columns: GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_VIEW()
      },
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_ASSETS_EVENTS_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'ASSET-EVENTS-BY-PE-RULE',
    dataLibraries: [
      {
        libraryName: 'ASSETS',
        columns: GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_BY_PE_RULE_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_BY_PE_RULE_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'DEVICE-EVENTS-BY-PE-RULE',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICE_EVENTS_BY_PE_RULE_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_DEVICE_EVENTS_BY_PE_RULE_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'ASSET-EVENTS-BY-SITE',
    dataLibraries: [
      {
        libraryName: 'ASSETS',
        columns: GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_BY_SITE_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_BY_SITE_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'DEVICE-EVENTS-BY-SITE',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICE_EVENTS_BY_SITE_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_DEVICE_EVENTS_BY_SITE_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'ASSET-EVENTS-BY-ASSET',
    dataLibraries: [
      {
        libraryName: 'ASSETS',
        columns: GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_BY_ASSET_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_BY_ASSET_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'DEVICE-EVENTS-BY-DEVICE',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICE_EVENTS_BY_DEVICE_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_DEVICE_EVENTS_BY_DEVICE_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'ASSET-EVENTS-BY-TOPIC',
    dataLibraries: [
      {
        libraryName: 'ASSETS',
        columns: GET_DEFAULT_ASSETS_COLUMNS_FOR_ASSET_EVENTS_BY_TOPIC_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_ASSET_EVENTS_BY_TOPIC_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'DEVICE-EVENTS-BY-TOPIC',
    dataLibraries: [
      {
        libraryName: 'DEVICES',
        columns: GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICE_EVENTS_BY_TOPIC_VIEW()
      },
      {
        libraryName: 'EVENTS',
        columns: GET_DEFAULT_EVENTS_COLUMNS_FOR_DEVICE_EVENTS_BY_TOPIC_VIEW()
      },
      {
        libraryName: 'TAGS',
        columns: []
      }
    ]
  },
  {
    viewType: 'PO-EVENT-RULES',
    dataLibraries: [
      {
        libraryName: 'PO EVENT RULES',
        columns: GET_DEFAULT_PO_EVENT_RULES_COLUMNS_FOR_PO_EVENT_RULES_VIEW()
      }
    ]
  },
  {
    viewType: 'USERS',
    dataLibraries: [
      {
        libraryName: 'USERS',
        columns: GET_DEFAULT_USERS_COLUMNS_FOR_USERS_VIEW()
      }
    ]
  },
  {
    viewType: 'PRODUCTS',
    dataLibraries: [
      {
        libraryName: 'PRODUCTS',
        columns: GET_DEFAULT_PRODUCTS_COLUMNS_FOR_PRODUCTS_VIEW()
      }
    ]
  },
  {
    viewType: 'ESCALATION-PROTOCOLS',
    dataLibraries: [
      {
        libraryName: 'ESCALATION PROTOCOLS',
        columns: GET_DEFAULT_ESCALATION_PROTOCOLS_COLUMNS_FOR_ESCALATION_PROTOCOLS_VIEW()
      }
    ]
  },
  {
    viewType: 'TOPICS',
    dataLibraries: [
      {
        libraryName: 'TOPICS',
        columns: GET_DEFAULT_TOPICS_COLUMNS_FOR_TOPICS_VIEW()
      }
    ]
  },
  {
    viewType: 'CALENDARS',
    dataLibraries: [
      {
        libraryName: 'CALENDARS',
        columns: GET_DEFAULT_CALENDARS_COLUMNS_FOR_CALENDARS_VIEW()
      }
    ]
  },
  {
    viewType: 'TEAM-PLANNINGS',
    dataLibraries: [
      {
        libraryName: 'TEAM PLANNINGS',
        columns: GET_DEFAULT_TEAM_PLANNINGS_COLUMNS_FOR_TEAM_PLANNINGS_VIEW()
      }
    ]
  },
  {
    viewType: 'SCHEDULERS',
    dataLibraries: [
      {
        libraryName: 'SCHEDULERS',
        columns: GET_DEFAULT_SCHEDULERS_COLUMNS_FOR_SCHEDULERS_VIEW()
      }
    ]
  }
];

export const getDefaultColumnsByConcept = (concept: I4bCellConcept | string): I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] => {
  const grid = defaultGridsDefinitions.find((defaultGrid) => defaultGrid.viewType.toLowerCase() === concept.toLowerCase());

  if (!grid) return [];

  return grid.dataLibraries
    .flatMap((library) => library.columns.filter((col) => col.configuration.isDefault))
    .sort((colA, colB) => colA.options.order - colB.options.order);
};

registerDefaultColumnsResolver(getDefaultColumnsByConcept);

export const getAllColumnsByConcept = (concept: I4bCellConcept | string): I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] => {
  const grid = defaultGridsDefinitions.find((defaultGrid) => defaultGrid.viewType.toLowerCase() === concept.toLowerCase());

  if (!grid) return [];

  return grid.dataLibraries.flatMap((library) => library.columns);
};

export const defaultSitesGrid: DefaultSitesGrid = new DefaultSitesGrid();
export const defaultStockSiteDevicesGrid: DefaultStockSiteDevicesGrid = new DefaultStockSiteDevicesGrid();
export const defaultAssetsGrid: DefaultAssetsGrid = new DefaultAssetsGrid();
export const defaultDevicesGrid: DefaultDevicesGrid = new DefaultDevicesGrid();
export const defaultDeviceEventsGrid: DefaultDeviceEventsGrid = new DefaultDeviceEventsGrid();
export const defaultAssetEventsGrid: DefaultAssetEventsGrid = new DefaultAssetEventsGrid();
export const defaultEmailTemplatesGrid: DefaultEmailTemplatesGrid = new DefaultEmailTemplatesGrid();
export const defaultConnectorsGrid: DefaultConnectorsGrid = new DefaultConnectorsGrid();
export const defaultActiveAssetEventsPopupGrid: DefaultActiveAssetEventsPopupGrid = new DefaultActiveAssetEventsPopupGrid();
export const defaultAssetEventsByPERuleGrid: DefaultAssetEventsByPERuleGrid = new DefaultAssetEventsByPERuleGrid();
export const defaultDeviceEventsByPERuleGrid: DefaultDeviceEventsByPERuleGrid = new DefaultDeviceEventsByPERuleGrid();
export const defaultAssetTemplatesGrid: DefaultAssetTemplatesGrid = new DefaultAssetTemplatesGrid();
export const defaultAssetEventsByTopicGrid: DefaultAssetEventsByTopicGrid = new DefaultAssetEventsByTopicGrid();
export const defaultDeviceEventsByTopicGrid: DefaultDeviceEventsByTopicGrid = new DefaultDeviceEventsByTopicGrid();
export const defaultAssetEventsBySiteGrid: DefaultAssetEventsBySiteGrid = new DefaultAssetEventsBySiteGrid();
export const defaultDeviceEventsBySiteGrid: DefaultDeviceEventsBySiteGrid = new DefaultDeviceEventsBySiteGrid();
export const defaultAssetEventsByAssetGrid: DefaultAssetEventsByAssetGrid = new DefaultAssetEventsByAssetGrid();
export const defaultDeviceEventsByDeviceGrid: DefaultDeviceEventsByDeviceGrid = new DefaultDeviceEventsByDeviceGrid();
export const defaultCalendarsGrid: DefaultCalendarsGrid = new DefaultCalendarsGrid();
export const defaultTeamPlanningsGrid: DefaultTeamPlanningsGrid = new DefaultTeamPlanningsGrid();
export const defaultProductsGrid: DefaultProductsGrid = new DefaultProductsGrid();
export const defaultEscalationProtocolsGrid: DefaultEscalationProtocolsGrid = new DefaultEscalationProtocolsGrid();
export const defaultSchedulersGrid: DefaultSchedulersGrid = new DefaultSchedulersGrid();
export const defaultTopicsGrid: DefaultTopicsGrid = new DefaultTopicsGrid();
